export default __webpack_public_path__ + "static/media/lonelydroid.6b82811c.svg";